import { createSelector } from '@reduxjs/toolkit'
import { cartSlice } from '@/store/cartSlice'
import { mapSelectors } from '@/store/mapSlice.ts'
import { getObjectsComparison } from '@/utils/getObjectsComparison'
import { normalizeReservation } from '@/utils/normalizeReservation'
import { normalizeSpot } from '@/utils/normalizeSpot'

export const selectActiveCartReservation = createSelector(
  [mapSelectors.selectedElement, cartSlice.selectors.cartReservations],
  (selectedElement, cartReservations) => {
    return cartReservations.find(
      (reservation) =>
        selectedElement &&
        getObjectsComparison(
          normalizeSpot(selectedElement),
          normalizeReservation(reservation)
        )
    )
  }
)
